import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Container,
  Image,
  Row,
} from 'react-bootstrap';
import { FaWhatsapp } from 'react-icons/fa';
import {
  FiArrowUpRight,
  FiCalendar,
  FiCheck,
  FiChevronLeft,
  FiChevronRight,
  FiCreditCard,
  FiGift,
  FiGlobe,
  FiLogIn,
  FiMail,
  FiSmartphone,
  FiX,
} from 'react-icons/fi';
import 'bootstrap/dist/css/bootstrap.min.css';
import imagyLogo from '../assets/imagy.png';
import imagySaludo from '../assets/imagySaludo2.png';
import { VISITAS_URL } from '../config/api';
import '../css/HomeSaaS.css';

const REGISTRO_DEMO_URL = 'https://clientes.imagy.ar/dashboard/demo';
const LOGIN_URL = 'https://clientes.imagy.ar/dashboard/login';
const WHATSAPP_NUMBER = '5491154688697';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=Hola,%20quiero%20probar%20Imagy%20en%20mi%20negocio`;
const FEATURE_ROTATION_MS = 10000;
const PLAN_ROTATION_MS = 9000;
const BUSINESS_ROTATION_MS = 5000;
const NEGOCIOS_LIST_API_URL = 'https://api-dashboard-9958.onrender.com/cloud/negocios/publicos';

const trackSignupClick = (ubicacion) => {
  const params = new URLSearchParams(window.location.search);
  const campaign = {
    ubicacion,
    utmSource: params.get('utm_source'),
    utmMedium: params.get('utm_medium'),
    utmCampaign: params.get('utm_campaign'),
  };

  fetch(`${VISITAS_URL}/evento`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ tipo: 'cta_registro', ...campaign }),
    keepalive: true,
  }).catch(() => undefined);
};

const normalizarNegocio = (negocio) => ({
  slug: negocio.slug,
  nombre: negocio.nombre || negocio.name || negocio.slug,
  logo: negocio.logoUrl || negocio.logo || '',
});

const extraerNegocios = (data) => {
  const listado = Array.isArray(data)
    ? data
    : data?.negocios || data?.businesses || data?.data || [];

  return Array.isArray(listado)
    ? listado.filter(({ slug }) => Boolean(slug)).map(normalizarNegocio)
    : [];
};

const funcionalidades = [
  {
    id: 'whatsapp',
    icon: FaWhatsapp,
    titulo: 'WhatsApp 24 h antes',
    resumen: 'El cliente recuerda, confirma o cancela sin que tengas que escribirle.',
  },
  {
    id: 'emails',
    icon: FiMail,
    titulo: 'Emails automáticos',
    resumen: 'Cliente y negocio reciben toda la información apenas se reserva.',
  },
  {
    id: 'deposito',
    icon: FiCreditCard,
    titulo: 'Seña opcional',
    resumen: 'Podés pedir comprobante antes de confirmar, solo cuando lo necesites.',
  },
];

const WhatsappPreview = () => (
  <div className="feature-phone">
    <div className="feature-phone__top">
      <span className="feature-phone__avatar">I</span>
      <div><strong>Imagy Notificaciones</strong><small>servicio automático</small></div>
      <i>•••</i>
    </div>
    <div className="feature-phone__chat">
      <div className="whatsapp-message">
        <p>✨ Hola Esteban!</p>
        <p>
          Tenés un turno de <strong>Corte de Estilo y Mantenimiento</strong><br />
          mañana a las <strong>10:30 hs.</strong>
        </p>
        <p>Al presionar un botón, tu negocio queda informado al instante.</p>
        <small>Este número solo envía notificaciones automáticas.</small>
        <time>13:56 ✓✓</time>
      </div>
      <button type="button">Confirmar turno</button>
      <button type="button">Cancelar turno</button>
    </div>
    <div className="feature-phone__note">
      <FiCheck /> Se envía automáticamente 24 horas antes
    </div>
  </div>
);

const EmailsPreview = () => (
  <div className="email-showcase">
    <article className="email-window">
      <div className="email-window__browser"><i /><i /><i /><span>Recibidos</span></div>
      <div className="email-window__subject">✅ Turno reservado — Kapping</div>
      <div className="calendar-invite">
        <FiCalendar />
        <div><small>mié, 30 sept · 11:30 a 13:00</small><strong>Kapping — Gisele Mateo Studio</strong></div>
      </div>
      <div className="email-body email-body--orange">
        <strong>✅ Turno reservado — Kapping</strong>
        <p>Hola Tadis 👋</p>
        <dl><dt>Negocio</dt><dd>Gisele Mateo Studio</dd><dt>Fecha</dt><dd>30/09 · 11:30</dd></dl>
      </div>
      <span className="email-window__label">El cliente recibe su confirmación</span>
    </article>

    <article className="email-window email-window--business">
      <div className="email-window__browser"><i /><i /><i /><span>Recibidos</span></div>
      <div className="email-window__subject">🗓️ Nueva reserva en tu agenda</div>
      <div className="email-body email-body--green">
        <strong>🗓️ Nueva reserva en tu agenda</strong>
        <p>Un cliente acaba de reservar un turno:</p>
        <dl><dt>Cliente</dt><dd>Luis</dd><dt>Servicio</dt><dd>Corte y mantenimiento</dd><dt>Horario</dt><dd>14:30 – 16:00</dd></dl>
      </div>
      <span className="email-window__label">El negocio se entera al instante</span>
    </article>
  </div>
);

const DepositPreview = () => (
  <div className="deposit-window">
    <div className="deposit-window__header"><strong>Reservar servicio</strong><span>×</span></div>
    <div className="deposit-window__progress"><span>Paso 4 de 4: pago</span></div>
    <div className="deposit-window__service">
      <strong>Corte de Estilo y Mantenimiento</strong>
      <small>Tadis | 11:00</small>
    </div>
    <p>Antes de confirmar, elegí cómo querés abonar la seña y subí el comprobante.</p>
    <div className="deposit-window__method">
      <FiCreditCard /><div><strong>Transferencia bancaria</strong><small>Usá los datos del negocio y subí el comprobante.</small></div>
    </div>
    <div className="deposit-window__bank"><strong>Datos para transferir</strong><span>Banco · Titular · Alias</span></div>
    <label>Comprobante <b>*</b><span>Seleccionar archivo</span><small>Imagen o PDF de hasta 2 MB</small></label>
    <div className="deposit-window__actions"><button type="button">Atrás</button><button type="button">Confirmar reserva</button></div>
  </div>
);

const FeaturePreview = ({ activeFeature }) => {
  if (activeFeature === 'emails') return <EmailsPreview />;
  if (activeFeature === 'deposito') return <DepositPreview />;
  return <WhatsappPreview />;
};

const HomeSaaS = () => {
  const [visible, setVisible] = useState(false);
  const [businesses, setBusinesses] = useState([]);
  const [activeBusinessIndex, setActiveBusinessIndex] = useState(0);
  const [activeFeature, setActiveFeature] = useState('whatsapp');
  const [activePlan, setActivePlan] = useState('trial');
  const [expandedPlans, setExpandedPlans] = useState({ trial: false, premium: false });
  const registroUrl = `${REGISTRO_DEMO_URL}${window.location.search}`;

  useEffect(() => {
    const controller = new AbortController();

    setVisible(true);
    fetch(`${VISITAS_URL}/registrar`, { method: 'POST' }).catch((error) =>
      console.warn('Error registrando visita:', error)
    );

    const cargarNegocios = async () => {
      try {
        const response = await fetch(NEGOCIOS_LIST_API_URL, {
          cache: 'no-store',
          signal: controller.signal,
        });
        if (!response.ok) throw new Error(`Error ${response.status} al cargar negocios`);

        const negociosActualizados = extraerNegocios(await response.json());
        if (!controller.signal.aborted) {
          setBusinesses(negociosActualizados);
          setActiveBusinessIndex(0);
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.warn('No se pudieron cargar los negocios:', error);
      }
    };

    cargarNegocios();

    return () => controller.abort();
  }, []);

  useEffect(() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return undefined;

    const timeout = window.setTimeout(() => {
      setActiveFeature((current) => {
        const currentIndex = funcionalidades.findIndex(({ id }) => id === current);
        return funcionalidades[(currentIndex + 1) % funcionalidades.length].id;
      });
    }, FEATURE_ROTATION_MS);

    return () => window.clearTimeout(timeout);
  }, [activeFeature]);

  useEffect(() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isMobile = window.matchMedia('(max-width: 767.98px)').matches;
    const activePlanIsExpanded = expandedPlans[activePlan];
    if (!isMobile || reduceMotion || activePlanIsExpanded) return undefined;

    const timeout = window.setTimeout(() => {
      setActivePlan((current) => (current === 'trial' ? 'premium' : 'trial'));
    }, PLAN_ROTATION_MS);

    return () => window.clearTimeout(timeout);
  }, [activePlan, expandedPlans]);

  useEffect(() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || businesses.length <= 1) return undefined;

    const interval = window.setInterval(() => {
      setActiveBusinessIndex((current) => (current + 1) % businesses.length);
    }, BUSINESS_ROTATION_MS);

    return () => window.clearInterval(interval);
  }, [businesses.length]);

  const visibleBusinesses = businesses.length
    ? [-1, 0, 1].map((offset) => ({
        ...businesses[(activeBusinessIndex + offset + businesses.length) % businesses.length],
        position: offset,
      }))
    : [];

  const showPreviousBusiness = () => {
    setActiveBusinessIndex((current) => (current - 1 + businesses.length) % businesses.length);
  };

  const showNextBusiness = () => {
    setActiveBusinessIndex((current) => (current + 1) % businesses.length);
  };

  return (
    <main className={`imagy-home ${visible ? 'is-visible' : ''}`}>
      <aside className="account-access" aria-label="Acceso para clientes de Imagy">
        <span>¿Ya empezaste?</span>
        <a href={LOGIN_URL}>
          <FiLogIn aria-hidden="true" />
          Ingresar a mi cuenta
        </a>
      </aside>

      <section className="marketing-hero">
        <Container className="marketing-container">
          <section className="top-plan-comparison" aria-labelledby="top-plan-comparison-title">
            <header className="top-plan-comparison__heading">
              <span>Todo lo que podés tener con Imagy</span>
              <h2 id="top-plan-comparison-title">Empezá gratis. Sumá WhatsApp cuando pases a Premium.</h2>
              <p>Estas condiciones corresponden a nuevas cuentas.</p>
            </header>

            <div
              key={`${activePlan}-${expandedPlans[activePlan]}`}
              className={`included-summary__plan-selector${expandedPlans[activePlan] ? ' is-paused' : ''}`}
              style={{ '--plan-duration': `${PLAN_ROTATION_MS}ms` }}
              role="group"
              aria-label="Elegir plan para comparar"
            >
              <button
                type="button"
                className={activePlan === 'trial' ? 'is-active' : ''}
                aria-pressed={activePlan === 'trial'}
                onClick={() => setActivePlan('trial')}
              >
                <FiGift /> Prueba gratis
              </button>
              <button
                type="button"
                className={activePlan === 'premium' ? 'is-active' : ''}
                aria-pressed={activePlan === 'premium'}
                onClick={() => setActivePlan('premium')}
              >
                <FaWhatsapp /> Premium
              </button>
            </div>

            <div className="included-summary__plans" aria-label="Planes de Imagy para nuevas cuentas">
              <article className={`included-summary__plan-card included-summary__plan-card--trial${activePlan === 'trial' ? ' is-active-plan' : ''}${expandedPlans.trial ? ' is-expanded' : ''}`}>
                <FiGift aria-hidden="true" />
                <div>
                  <span>Prueba gratis · Primer mes</span>
                  <h3>$0 durante 1 mes</h3>
                  <p>Todo lo necesario para publicar tu negocio y empezar a recibir turnos.</p>
                  <div className="included-summary__whatsapp-status is-unavailable">
                    <FiX /> Sin notificaciones por WhatsApp
                  </div>
                  <ul>
                    <li><FiCheck /> Página propia con tu enlace, logo, servicios y precios</li>
                    <li><FiCheck /> Reservas online las 24 horas</li>
                    <li><FiCheck /> Agenda, horarios, profesionales y clientes</li>
                    <li><FiCheck /> Notificaciones automáticas por email</li>
                    <li><FiCheck /> Acceso desde celular o computadora</li>
                    <li><FiCheck /> Campañas con promociones para tus clientes</li>
                    <li><FiCheck /> Newsletter para mantener informados a tus clientes</li>
                    <li><FiCheck /> Seña opcional para confirmar reservas</li>
                    <li><FiCheck /> Gift cards para vender y regalar</li>
                    <li><FiCheck /> Control de stock de productos</li>
                    <li><FiCheck /> Galería para subir fotos de tus trabajos</li>
                    <li><FiCheck /> Calificaciones y opiniones de tus clientes</li>
                    <li><FiCheck /> Consulta de turnos desde la página, sin login</li>
                    <li><FiCheck /> Confirmación de turnos desde la página, sin login</li>
                    <li><FiCheck /> Cancelación de turnos desde la página, sin login</li>
                    <li className="is-not-included"><FiX /> Recordatorios de turnos por WhatsApp</li>
                    <li className="is-not-included"><FiX /> Confirmación de turnos por WhatsApp</li>
                    <li className="is-not-included"><FiX /> Cancelación de turnos por WhatsApp</li>
                  </ul>
                  <button
                    type="button"
                    className="included-summary__plan-toggle"
                    aria-expanded={expandedPlans.trial}
                    onClick={() => setExpandedPlans((plans) => ({ ...plans, trial: !plans.trial }))}
                  >
                    {expandedPlans.trial ? 'Ver menos' : 'Ver todas las funciones'}
                  </button>
                </div>
              </article>

              <article className={`included-summary__plan-card included-summary__plan-card--premium${activePlan === 'premium' ? ' is-active-plan' : ''}${expandedPlans.premium ? ' is-expanded' : ''}`}>
                <b className="included-summary__recommended">Premium</b>
                <FaWhatsapp aria-hidden="true" />
                <div>
                  <span>Después del primer mes</span>
                  <h3>Premium · $15.000 ARS/mes</h3>
                  <p>Conservás todas las herramientas de la prueba y agregás WhatsApp automático.</p>
                  <div className="included-summary__whatsapp-status is-available">
                    <FiCheck /> Notificaciones por WhatsApp incluidas
                  </div>
                  <ul>
                    <li><FiCheck /> Página propia con tu enlace, logo, servicios y precios</li>
                    <li><FiCheck /> Reservas online las 24 horas</li>
                    <li><FiCheck /> Agenda, horarios, profesionales y clientes</li>
                    <li><FiCheck /> Notificaciones automáticas por email</li>
                    <li><FiCheck /> Acceso desde celular o computadora</li>
                    <li><FiCheck /> Campañas con promociones para tus clientes</li>
                    <li><FiCheck /> Newsletter para mantener informados a tus clientes</li>
                    <li><FiCheck /> Seña opcional para confirmar reservas</li>
                    <li><FiCheck /> Gift cards para vender y regalar</li>
                    <li><FiCheck /> Control de stock de productos</li>
                    <li><FiCheck /> Galería para subir fotos de tus trabajos</li>
                    <li><FiCheck /> Calificaciones y opiniones de tus clientes</li>
                    <li><FiCheck /> Consulta de turnos desde la página, sin login</li>
                    <li><FiCheck /> Confirmación de turnos desde la página, sin login</li>
                    <li><FiCheck /> Cancelación de turnos desde la página, sin login</li>
                    <li><FiCheck /> Recordatorios de turnos por WhatsApp</li>
                    <li><FiCheck /> Confirmación de turnos por WhatsApp</li>
                    <li><FiCheck /> Cancelación de turnos por WhatsApp</li>
                  </ul>
                  <button
                    type="button"
                    className="included-summary__plan-toggle"
                    aria-expanded={expandedPlans.premium}
                    onClick={() => setExpandedPlans((plans) => ({ ...plans, premium: !plans.premium }))}
                  >
                    {expandedPlans.premium ? 'Ver menos' : 'Ver todas las funciones'}
                  </button>
                </div>
              </article>
            </div>
          </section>

          <Row className="align-items-center g-4">
            <Col lg={6} className="marketing-hero__copy">
              <div className="marketing-brand">
                <Image src={imagyLogo} alt="Imagy" />
                <div><strong>Imagy</strong><span>Turnos simples. Negocios más ordenados.</span></div>
              </div>

              <span className="marketing-eyebrow">Probá Imagy gratis por 1 mes · Sin tarjeta</span>
              <h1>Tus clientes reservan solos. Vos seguís trabajando.</h1>
              <p>
                Compartí tu enlace por Instagram o WhatsApp. Tus clientes eligen
                servicio y horario sin crear una cuenta ni instalar una app.
              </p>

              <div className="business-link-example" aria-label="Ejemplo del enlace público de un negocio">
                <FiGlobe aria-hidden="true" />
                <div>
                  <span>Este es el enlace que compartís</span>
                  <strong>clientes.imagy.ar/negocio/tu-negocio</strong>
                </div>
              </div>

              <div className="marketing-actions">
                <Button href={registroUrl} className="marketing-primary" onClick={() => trackSignupClick('hero')}>
                  Probar gratis por 1 mes <FiArrowUpRight aria-hidden="true" />
                </Button>
              </div>

              <div className="assistant-promise">
                <img src={imagySaludo} alt="Imagy, tu asistente para crear la página de tu negocio" />
                <div>
                  <strong>Creá tu página en minutos.</strong>
                  <span>Imagy te guía paso a paso y nuestro equipo puede ayudarte cuando lo necesites.</span>
                </div>
              </div>

              <div className="marketing-trust">
                <span><FiCheck /> Sin tarjeta</span>
                <span><FiSmartphone /> Celular o computadora</span>
                <span><FiCheck /> App instalable opcional</span>
              </div>
            </Col>

            <Col lg={6}>
              <section className="business-showcase" id="negocios-imagy" aria-labelledby="business-showcase-title">
                <header className="business-showcase__header">
                  <span><i aria-hidden="true" /> Negocios activos en Imagy</span>
                  <h2 id="business-showcase-title">Negocios reales. Reservas reales.</h2>
                  <p>Conocé a quienes ya reciben reservas online con Imagy.</p>
                </header>

                <div className="business-carousel" aria-live="polite">
                  <div className="business-carousel__cards">
                    {visibleBusinesses.map((negocio) => (
                      <a
                        className={`business-card business-card--${negocio.position === 0 ? 'active' : 'side'}`}
                        href={`https://clientes.imagy.ar/negocio/${negocio.slug}`}
                        key={`${negocio.position}-${negocio.slug}`}
                      >
                        {negocio.logo ? (
                          <img src={negocio.logo} alt={`Logo de ${negocio.nombre}`} loading="lazy" />
                        ) : (
                          <div className="business-card__placeholder" aria-hidden="true">
                            {negocio.nombre.charAt(0).toUpperCase()}
                          </div>
                        )}
                      <div className="business-card__body">
                        <h3>{negocio.nombre}</h3>
                        <span>Agenda online y reservas</span>
                        <strong>Ver agenda <FiArrowUpRight aria-hidden="true" /></strong>
                      </div>
                      </a>
                    ))}
                  </div>

                  <div className="business-carousel__controls">
                    <button type="button" onClick={showPreviousBusiness} aria-label="Ver negocio anterior">
                      <FiChevronLeft aria-hidden="true" />
                    </button>
                    <div aria-label={`Negocio ${activeBusinessIndex + 1} de ${businesses.length}`}>
                      {businesses.map((negocio, index) => (
                        <button
                          type="button"
                          className={index === activeBusinessIndex ? 'is-active' : ''}
                          onClick={() => setActiveBusinessIndex(index)}
                          aria-label={`Ver ${negocio.nombre}`}
                          aria-current={index === activeBusinessIndex ? 'true' : undefined}
                          key={negocio.slug}
                        />
                      ))}
                    </div>
                    <button type="button" onClick={showNextBusiness} aria-label="Ver negocio siguiente">
                      <FiChevronRight aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </section>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="feature-proof-section" style={{ '--feature-duration': `${FEATURE_ROTATION_MS}ms` }}>
        <Container className="marketing-container">
          <header className="feature-proof-heading">
            <div>
              <span>Esto es lo que hace Imagy por vos</span>
              <h2>Menos mensajes. Menos ausencias. Más turnos confirmados.</h2>
            </div>
            <p>
              No es solo una agenda: acompaña cada reserva automáticamente para
              que vos puedas concentrarte en atender.
            </p>
          </header>

          <div className="feature-tabs" role="tablist" aria-label="Funciones de Imagy">
            {funcionalidades.map(({ id, icon: Icon, titulo, resumen }) => (
              <button
                type="button"
                role="tab"
                aria-selected={activeFeature === id}
                className={activeFeature === id ? 'is-active' : ''}
                key={id}
                onClick={() => setActiveFeature(id)}
              >
                <Icon aria-hidden="true" />
                <span><strong>{titulo}</strong><small>{resumen}</small></span>
              </button>
            ))}
          </div>

          <div
            key={activeFeature}
            className={`feature-stage feature-stage--${activeFeature}`}
            role="tabpanel"
            aria-live="polite"
          >
            <div className="feature-stage__copy">
              {activeFeature === 'whatsapp' && (
                <>
                  <span>Función de Imagy Premium</span>
                  <h3>Tu cliente recibe un WhatsApp 24 horas antes.</h3>
                  <p>Después del mes gratis, las nuevas cuentas pueden continuar con Premium por $15.000 ARS al mes. El cliente puede confirmar o cancelar y tu agenda se actualiza sola.</p>
                </>
              )}
              {activeFeature === 'emails' && (
                <>
                  <span>Incluido durante tu mes de prueba</span>
                  <h3>Cada reserva genera emails automáticos.</h3>
                  <p>El cliente recibe su comprobante y calendario. Vos recibís los datos completos del nuevo turno.</p>
                </>
              )}
              {activeFeature === 'deposito' && (
                <>
                  <span>Más seguridad para tu agenda</span>
                  <h3>Pedí una seña solo si tu negocio la necesita.</h3>
                  <p>Configurás los datos de pago y el cliente adjunta su comprobante antes de finalizar la reserva.</p>
                </>
              )}
              <ul>
                <li><FiCheck /> {activeFeature === 'whatsapp' ? 'Incluido en Imagy Premium' : 'Incluido en el mes de prueba'}</li>
                <li><FiCheck /> Navegador o app instalable</li>
                <li><FiCheck /> Configurable desde tu panel</li>
              </ul>
            </div>
            <div className="feature-stage__preview">
              <FeaturePreview activeFeature={activeFeature} />
            </div>
          </div>

          <div className="included-summary">
            <div className="included-summary__heading">
              <div>
                <span>Una sola herramienta</span>
                <h3>Todo lo que necesitás para recibir reservas y ordenar tu negocio.</h3>
              </div>
              <div className="included-summary__mobile">
                <FiSmartphone aria-hidden="true" />
                <div>
                  <strong>Aplicación móvil para tu negocio</strong>
                  <p>Instalá Imagy en Android o iPhone y manejá agenda, reservas, clientes y configuración desde tu celular.</p>
                </div>
              </div>
            </div>

            <div className="included-summary__grid">
              <article>
                <FiGlobe aria-hidden="true" />
                <h4>Página profesional</h4>
                <ul>
                  <li><FiCheck /> Tu enlace con logo, servicios y precios</li>
                  <li><FiCheck /> Tus clientes reservan sin cuenta ni app</li>
                </ul>
              </article>
              <article>
                <FiCalendar aria-hidden="true" />
                <h4>Agenda inteligente</h4>
                <ul>
                  <li><FiCheck /> Horarios, profesionales y reservas manuales</li>
                  <li><FiCheck /> Usala en celular, computadora o como app</li>
                </ul>
              </article>
              <article>
                <FiMail aria-hidden="true" />
                <h4>Clientes informados</h4>
                <ul>
                  <li><FiCheck /> Emails de reserva y confirmación</li>
                  <li><FiCheck /> Consulta, confirmación o cancelación online</li>
                </ul>
              </article>
              <article>
                <FiGift aria-hidden="true" />
                <h4>Más formas de vender</h4>
                <ul>
                  <li><FiCheck /> Señas por transferencia o enlace de pago</li>
                  <li><FiCheck /> Gift cards, campañas y opiniones reales</li>
                </ul>
              </article>
            </div>

            <div className="included-summary__footer">
              <p><strong>Probá Imagy gratis por 1 mes:</strong> sin tarjeta y sin notificaciones por WhatsApp.</p>
              <Button href={registroUrl} className="marketing-primary" onClick={() => trackSignupClick('funciones')}>
                Empezar mi mes gratis <FiArrowUpRight />
              </Button>
            </div>
          </div>
        </Container>
      </section>

      <a className="whatsapp-float" href={WHATSAPP_URL} target="_blank" rel="noreferrer" aria-label="Hablar por WhatsApp">
        <FaWhatsapp />
      </a>

    </main>
  );
};

export default HomeSaaS;
